import React from "react";
import { DiscussionIcon, Header2, NoteIcon, PinIcon } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import HiddenFromClients from "~/components/tasks/Signifiers/HiddenFromClients";
import { ProjectTemplateElementsOptionsContainer } from "../ProjectTemplateElementsOptionsContainer";
import { PROJECT_TEMPLATE_DISCUSSION, PROJECT_TEMPLATE_NOTE } from "../utils";

const TemplateDiscussionAndNoteHeader = ({ element, className }) => {
  const isPinned = element?.is_pinned;
  const isHiddenFromClients = element?.is_hidden_from_clients;

  return (
    <div className={classNames("tw-relative", className)}>
      <div className="tw-flex tw-justify-between tw-mb-2">
        <div>
          {element.class === PROJECT_TEMPLATE_DISCUSSION && (
            <DiscussionIcon
              className="tw-mr-3 tw-align-middle"
              fill="var(--color-theme-800)"
            />
          )}
          {element.class === PROJECT_TEMPLATE_NOTE && (
            <NoteIcon
              className="tw-mr-3 tw-align-middle"
              fill="var(--color-theme-800)"
            />
          )}
          <Header2
            weight="bold"
            className="tw-mr-1 tw-align-middle"
            as="span"
          >
            {element.name}
          </Header2>
          {isPinned ? (
            <div className="tw-inline-flex tw-items-center modal-header-icon tw-align-middle">
              <PinIcon />
            </div>
          ) : null}
          <HiddenFromClients
            hiddenFromClients={isHiddenFromClients}
            className="modal-header-icon tw-inline-flex tw-align-middle"
          />
        </div>
        <div className="tw-flex tw-h-fit tw--mt-1 tw-ml-2">
          <ProjectTemplateElementsOptionsContainer
            elementId={element?.id}
            elementType={element?.class}
            templateId={element?.template_id}
          />
        </div>
      </div>
    </div>
  );
};

TemplateDiscussionAndNoteHeader.propTypes = {
  element: PropTypes.object,
  className: PropTypes.string,
};

TemplateDiscussionAndNoteHeader.displayName = "TemplateDiscussionsModalHeader";

export default TemplateDiscussionAndNoteHeader;
